
export default {
  name: 'EleAvatarList',
  props: {
    // 头像数据
    data: {
      type: Array,
      required: true
    },
    // 最大显示个数
    max: {
      type: Number,
      default: 0
    },
    // name字段名
    name: {
      type: String,
      default: 'name'
    },
    // avatar字段名
    avatar: {
      type: String,
      default: 'avatar'
    },
    // avatar形状
    shape: {
      type: String,
      default: 'circle'
    },
    // avatar大小
    size: {
      type: [Number, String],
      default: 'default'
    },
    // 自定义item样式
    itemStyle: [String, Object],
    // 自定义avatar样式
    avatarStyle: [String, Object],
    // 自定义more样式
    moreStyle: [String, Object],
    // 是否需要tooltip
    tooltip: {
      type: Boolean,
      default: true
    },
    // tooltip位置
    placement: {
      type: String,
      default: 'top'
    },
    // tooltip自定义class
    overlayClassName: String,
    // tooltip自定义样式
    overlayStyle: String
  },
  computed: {
    // 公共样式
    commonStyle() {
      if (typeof this.size === 'number') {
        return {
          marginLeft: `${-this.size / 3}px`
        };
      } else {
        return {
          marginLeft: {large: '-12px', default: '-10px', small: '-8px'}[this.size]
        };
      }
    },
    // 头像列表
    list() {
      if (!this.max || this.data.length <= this.max) {
        return this.data;
      }
      return this.data.slice(0, this.max);
    },
    // 是否显示更多
    showMore() {
      return this.max && this.data.length > this.max;
    }
  }
}
